import React from "react";
import UserCreateForm from "../forms/UserCreateForm";
import { Container } from "@airbus/components-react";


class UserCreateView extends React.Component {

    constructor(props){
        super(props);

        //Notification params
        this.setNotification=this.props.notificationHandler;  //call parent notification handler
               
        
    }

    componentDidMount(){
        //debugger;
    }

    /**
     * RENDERING
     * @returns dom
     */
    render() { return(
        <Container >

            {/* CREATE USER DISPLAY */}
            <UserCreateForm notificationHandler={this.setNotification}/>

        </Container>
    )}
    

  

}

export default UserCreateView;